<script>
  import { domainName, record, newRecordCreated } from '../stores.js';
  import BIMISearch from './bimiSearch.svelte';
  import BIMIResult from './bimiResult.svelte';
  import Tools from '../Tools.svelte';
</script>

<svelte:head>
  <script src="//info.agari.com/js/forms2/js/forms2.min.js"></script>
</svelte:head>

{#if $domainName == '' }
  <BIMISearch />
  <Tools skip={'bimi'} />
{:else}
  <BIMIResult />
{/if}

<style>

</style>
